import axios from './../constants/axios';
import * as types from './../constants/actionTypes';
import { reset, SubmissionError } from 'redux-form';
import alert from 'alertify.js';

export function loadShopSuccess(payload) {
   return { type: types.GET_ALL_SHOPS_SUCCESS, payload: payload };
}

export function createShopSuccess(payload) {
   return { type: types.CREATE_SHOP_SUCCESS, payload: payload };
}

export function createCategorySuccess(payload) {
   return { type: types.CREATE_CATEGORY_SUCCESS, payload: payload };
}

export function createSubCategorySuccess(payload) {
   return { type: types.CREATE_SUB_CATEGORY_SUCCESS, payload: payload };
}


export function loadShops() {
   return function (dispatch) {
      return axios
         .get('shops/allShopWithCategorySubCategory')
         .then(function (res) {
            dispatch(loadShopSuccess({
               shops: res.data
            }));
         });
   };
}

export function createShop(shop) {
   return function (dispatch) {
      return axios
         .post('shops', shop)
         .then(function (res) {
            dispatch(createShopSuccess({
               shop: res.data
            }));
            dispatch(reset('newShopForm'));
            alert.success('Shop Created.');
         })
         .catch((err) => {
            throw  new SubmissionError(err.response.data);
         });
   };
}

export function createCategory(category, shopId) {
   // make an ajax call
   return function (dispatch) {
      return axios
         .post('shops/' + shopId + '/categories', category)
         .then(function (res) {
            dispatch(createCategorySuccess({
               shopId: shopId,
               category: res.data
            }));
            dispatch(reset('newCategoryForm'));
            alert.success('Shop Created.');
         })
         .catch((err) => {
            throw  new SubmissionError(err.response.data);
         });
   };
}

export function createSubCategory(subCategory, shopId, categoryId) {
   // make an ajax call
   return function (dispatch) {
      return axios
         .post('shops/' + shopId + '/categories/' + categoryId + '/subCategories', subCategory)
         .then(function (res) {
            dispatch(createSubCategorySuccess({
               shopId: shopId,
               categoryId: categoryId,
               subCategory: res.data
            }));
            dispatch(reset('newSubCategoryForm'));
            alert.success('Shop Created.');
         })
         .catch((err) => {
            throw  new SubmissionError(err.response.data);
         });
   };
}




/** WEBPACK FOOTER **
 ** ./src/actions/shopActions.js
 **/